import api from './api';
import { PaginatedResponse } from '../types';
import { MonitoringTarget, GetMonitoringTargetsParams } from '../types/monitoring';

export const getMonitoringTargets = (params: GetMonitoringTargetsParams) => {
  return api.get<PaginatedResponse<MonitoringTarget>>('/monitoring/targets', { params });
};
